import React from "react";
import "../../Styles/find.css";
import { useNavigate } from "react-router-dom";

const Find = () => {
  const navigate = useNavigate()
  return (
    <>
      <section className="find-main">
        <div className="container-fluid find-container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-xl-6 find-left-main">
              <h4>We Are Help To You Find Properties</h4>
              <h6>
                Over 747k listings of apartments, lots, plots available today.
              </h6>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-6 find-bg"></div>
          </div>
          <div className="container find-crd">
            <div className="row find-row">
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="find-card">
                  <img src="/images/house.png" alt="home-icon" />
                  <h6>Sell A Home</h6>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.{" "}
                  </p>
                  <button onClick={() => navigate(`/property-listing?type=sell`)}>Buy Home</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="find-card">
                  <img src="/images/rent.png" alt="home-icon" />
                  <h6>Rent A House</h6>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.{" "}
                  </p>
                  <button onClick={() => navigate(`/property-listing?type=rent`)}>Buy Rent House</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="find-card">
                  <img src="/images/engineering.png" alt="home-icon" />
                  <h6>Developer</h6>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.{" "}
                  </p>
                  <button onClick={() => navigate(`/property-listing?type=developer`)}>View Developer</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Find;
